/**
 * ResponsiveRoute — wrapper yang auto-switch antara desktop & mobile page.
 * Dipakai di App.tsx routes supaya satu URL, tampilan beda berdasarkan device.
 */
import type { ReactNode } from 'react';
import { useIsMobile } from '../hooks/use-is-mobile';

/**
 * ResponsiveRoute({ mobile: <MobileDashboard />, desktop: <Dashboard /> })
 * → Otomatis render salah satu berdasarkan mobile detection (width + touch + UA).
 */
export function ResponsiveRoute({
  mobile,
  desktop,
}: {
  mobile: ReactNode;
  desktop: ReactNode;
}) {
  const isMobile = useIsMobile();
  return <>{isMobile ? mobile : desktop}</>;
}
